import { useRef, useEffect } from "react";
import { Bold, Italic, Heading2, Heading3, List, ListOrdered, Quote, Link2, Image as ImageIcon, Code, Minus } from "lucide-react";

export default function RichTextEditor({ value, onChange, testid = "rte" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = () => onChange(ref.current.innerHTML);
  const exec = (cmd, arg = null) => { document.execCommand(cmd, false, arg); ref.current.focus(); emit(); };
  const addLink = () => { const url = prompt("Enter link URL"); if (url) exec("createLink", url); };
  const addImage = () => { const url = prompt("Enter image URL"); if (url) exec("insertImage", url); };

  const tools = [
    { icon: Heading2, run: () => exec("formatBlock", "H2"), t: "h2", title: "Heading" },
    { icon: Heading3, run: () => exec("formatBlock", "H3"), t: "h3", title: "Subheading" },
    { icon: Bold, run: () => exec("bold"), t: "bold", title: "Bold" },
    { icon: Italic, run: () => exec("italic"), t: "italic", title: "Italic" },
    { icon: List, run: () => exec("insertUnorderedList"), t: "ul", title: "Bullet list" },
    { icon: ListOrdered, run: () => exec("insertOrderedList"), t: "ol", title: "Numbered list" },
    { icon: Quote, run: () => exec("formatBlock", "BLOCKQUOTE"), t: "quote", title: "Quote" },
    { icon: Link2, run: addLink, t: "link", title: "Link" },
    { icon: ImageIcon, run: addImage, t: "image", title: "Image by URL" },
    { icon: Code, run: () => exec("formatBlock", "PRE"), t: "code", title: "Code block" },
    { icon: Minus, run: () => exec("insertHorizontalRule"), t: "hr", title: "Divider" },
  ];

  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden bg-white" data-testid={testid}>
      <div className="flex flex-wrap gap-1 border-b border-slate-200 bg-slate-50 p-2">
        {tools.map((tl) => (
          <button key={tl.t} type="button" title={tl.title} onMouseDown={(e) => e.preventDefault()} onClick={tl.run} data-testid={`${testid}-${tl.t}`}
            className="h-8 w-8 inline-flex items-center justify-center rounded-md text-slate-600 hover:bg-white hover:text-navy border border-transparent hover:border-slate-200 transition-colors">
            <tl.icon size={16} />
          </button>
        ))}
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={emit} data-testid={`${testid}-area`} data-placeholder="Write your article…"
        className="rte-content min-h-[300px] max-h-[560px] overflow-y-auto px-4 py-3 text-sm text-slate-700 focus:outline-none" />
    </div>
  );
}
